export const APP_CONSTANTS = {
	IdHierarchyTypeForRights: 1000005,
    SecurableEntityIdForCompany: 26,
    LocalAppId: 21
}